import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import OngoingCount from "./OngoingCount";
import IconProject from "../iconComponents/IconProjects";
import IconContract from "../iconComponents/IconContract";
import IconIncoming from "../iconComponents/IconIncoming";
import IconOutgoing from "../iconComponents/IconOutgoing";
import IconInvoice from "../iconComponents/IconInvoices";

export function OngoingCounts(props) {

const dashboard = useSelector(state => state.dashboard.dashboard);

const [digits, setDigits] = useState(2);

useEffect(() => {
    // Use same number of digits for all items, starting at at least 2 digits
    let largest = Math.max(dashboard.project_active_count, dashboard.contract_active_count, dashboard.contract_pending_count, dashboard.invoice_incoming_active_count, dashboard.invoice_outgoing_active_count);
    let maxDigits = largest.toString().length;
    maxDigits > 1 && setDigits(maxDigits);
    maxDigits < 2 && setDigits(2);
}, [dashboard.project_active_count, dashboard.contract_active_count, dashboard.contract_pending_count, dashboard.invoice_incoming_active_count, dashboard.invoice_outgoing_active_count])

    return (
        <div className="w charts-wrapper counts gap-below-s gap-right-s" >
            <h3 className="title2 gap-below-m">Ongoing Counts</h3>
            <OngoingCount 
                value={dashboard.project_active_count}
                title="Active Projects"
                digits={digits} 
            >
                <IconProject className="iblock gap-right-xs" pathClass="g7-fill" height="22px" />
            </OngoingCount>
            <hr className="gap-above-xs gap-below-xs" />
            <OngoingCount
                value={dashboard.contract_active_count}
                title="Active Contracts"
                digits={digits}
            >
                <IconContract className="iblock gap-right-xs" pathClass="g7-fill" height="22px" />
            </OngoingCount>
            <hr className="gap-above-xs gap-below-xs" />
            <OngoingCount
                value={dashboard.contract_pending_count}
                title="Pending Contracts"
                digits={digits}
            >
                <IconContract className="iblock gap-right-xs" pathClass="g7-fill" height="22px" />
            </OngoingCount>
            <hr className="gap-above-xs gap-below-xs" />
            <OngoingCount
                value={dashboard.invoice_incoming_active_count}
                title="Active Invoices Incoming"
                digits={digits} 
            >
                <IconInvoice className="iblock gap-right-xs" pathClass="g7-fill" height="22px" />
                <IconIncoming className="iblock gap-right-xs" pathClass="tb7-fill" height="22px" />
            </OngoingCount>
            <hr className="gap-above-xs gap-below-xs" />
            <OngoingCount 
                value={dashboard.invoice_outgoing_active_count}
                title="Active Invoices Outgoing"
                digits={digits} 
            >
                <IconInvoice className="iblock gap-right-xs" pathClass="g7-fill" height="22px" />
                <IconOutgoing className="iblock gap-right-xs" pathClass="p5-fill" height="22px" />
            </OngoingCount>
        </div>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(OngoingCounts);